import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';
import { P } from './portal-permissions.constants';

function multiRead(
  pattern: string,
  permissionKeys: string[],
  methods: ('GET' | 'POST')[] = ['GET', 'POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys,
    access: 'read' as const,
  }));
}

/**
 * Analiz modülü endpoint'leri.
 * Genel Bakış ve Baz Yıl Karşılaştırma paylaşılan lookup'lar.
 */
export const ANALIZ_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] = [
  ...multiRead('api/Emission/CompareYearData', [
    P.Analiz.BazYilKarsilastirma,
  ]),

  ...multiRead(
    'api/Emission/GetCompareYears',
    [P.Analiz.GenelBakis, P.Analiz.BazYilKarsilastirma],
    ['GET'],
  ),

  ...multiRead('api/Emission/GetApplicationEmissionDataByCategory', [
    P.Analiz.GrupSirketleri,
  ]),

  /** Dashboard filtre dropdown'ları — Analiz read yeterli */
  ...multiRead('api/Company/GetLocations', [
    P.Analiz.GenelBakis,
    P.Yonetim.Lokasyonlar,
  ]),
  ...multiRead('api/Company/GetEquipments', [
    P.Analiz.GenelBakis,
    P.Yonetim.Ekipmanlar,
    P.EmisyonFaktorleri.Kaynak,
  ]),
  ...multiRead('api/Emission/GetEmissionProtocols', [
    P.Analiz.GenelBakis,
    P.Hesaplama.GecmisYillar,
    P.Hesaplama.VeriGirisi,
  ]),
];
